<template>
    <div class="bg-white">
        <div class="p-5 md:py-12 xl:py-24 2xl:py-32 login-page border-b border-gray-200">
            <div class="mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4">
                <div class="faded border-gray-200 border p-4 rounded-t-lg">

                    <h1 class="font-semibold text-2xl mb-1">You have opted out of emails from {{
                            $parent.consumerPortalName
                        }}.</h1>
                    <p v-if="done">You will no longer receive e-mails from {{ $parent.consumerPortalName }}.</p>
                    <p v-else>Your feedback matters. Please let us know why you unsubscribed. This is optional and will
                        not affect
                        your unsubscribed preference:</p>

                    <form v-if="! done" method="POST" @submit.prevent="save">
                        <ul class="my-4 space-y-2">
                            <li v-for="(reason, i) in reasons">
                                <label :for="`reason_${i}`" class="flex items-center">
                                    <input v-model="feedback" :id="`reason_${i}`" type="checkbox"
                                           class="border-gray-400 border p-2 rounded" :value="reason">&nbsp;
                                    {{ reason.text }}
                                </label>
                            </li>
                            <!--                            <li>-->
                            <!--                                <label for="reason_5" class="flex items-center mb-2">-->
                            <!--                                    <input v-model="allowOther" id="reason_5" type="checkbox" class="border-gray-400 border p-2 rounded">&nbsp; Other-->
                            <!--                                </label>-->
                            <!--                                <textarea name="other" v-model="other" :required="! allowOther" :disabled="! allowOther" :class="{ 'bg-gray-200 opacity-50 cursor-not-allowed': ! allowOther }" rows="6" class="border-gray-400 border p-2 rounded w-full"></textarea>-->
                            <!--                            </li>-->
                        </ul>
                        <input type="submit" class="border-gray-400 border p-2 rounded">
                        <p v-if="error" v-text="error" class="mt-2 font-semibold"/>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['feedback-allowed', 'account', 'email-id', 'reasons'],

    mounted() {
        if (!this.feedbackAllowed) this.done = true;
    },

    data() {
        return {
            error: '',
            done: false,
            allowOther: false,
            other: null,
            feedback: []
        }
    },

    methods: {
        /**
         * @returns {void}
         */
        save() {
            let reasons = [...this.feedback];
            let showOffer = false;

            if (this.allowOther) reasons.push({
                text: this.other,
                showPopupOffer: false
            });

            if (!reasons.length) {
                this.error = 'Must select at least one option to submit feedback.';

                return;
            }

            let url = `${this.$parent.consumerPortalBaseUrl}/api/email-opt-out/${this.account.id}`;

            if (this.emailId) url = `${url}/${this.emailId}`;

            reasons = reasons.map(reason => {
                if (reason.hasOwnProperty('showPopupOffer') && reason.showPopupOffer) {
                    showOffer = true;
                }

                return reason.text;
            });

            this.$http.post(url, {reasons}).then(() => {
                this.done = true;

                if (showOffer) this.$root.$emit('show-special-offer-popup', this.account.id);
            });
        }
    }
}
</script>
